type Props = {
  value: string;
  onChange: (v: string) => void;
  matchedRunCount: number;
  totalMatchCount: number;
  totalRuns: number;
};

// Search bar — single input + clear button + live counter. Lives in the
// Summary strip; controlled by App. Empty value means "no filter".
export function SearchBar({
  value,
  onChange,
  matchedRunCount,
  totalMatchCount,
  totalRuns,
}: Props) {
  const isSearching = value.trim().length > 0;
  return (
    <div className="searchbar">
      <div className="searchbar__input-wrap">
        <input
          className="searchbar__input"
          type="search"
          placeholder="Search packages, URLs, advisory IDs, sources…"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoFocus
        />
        {isSearching && (
          <button
            className="searchbar__clear"
            onClick={() => onChange("")}
            title="Clear search"
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
      {isSearching ? (
        <span className="searchbar__counter">
          {matchedRunCount === 0 ? (
            <span className="searchbar__counter--empty">no matches</span>
          ) : (
            <>
              <strong>{matchedRunCount}</strong> {matchedRunCount === 1 ? "run" : "runs"} ·{" "}
              <strong>{totalMatchCount}</strong> {totalMatchCount === 1 ? "hit" : "hits"}
            </>
          )}
        </span>
      ) : (
        <span className="searchbar__counter searchbar__counter--idle">
          searching across {totalRuns} {totalRuns === 1 ? "run" : "runs"}
        </span>
      )}
    </div>
  );
}
